type AnalyticsInfo = {
  gaTrackingId?: string | null;
  heapAppId?: string | null;
  appcuesAccountId?: string | null;
  identity: string;
  contextPath?: string | null;
  isImpersonating?: boolean | null;
  userProperties?: { [key: string]: unknown } | null;
  eventProperties?: AnalyticsEventProperties | null;
  activityTrackingInterval?: number | null;
  cookieDomain?: string | null;
};

type AnalyticsEventProperties = {
  userPrincipalId?: string | null;
  isImpersonating?: boolean | null;
} & { [key: string]: unknown };

type AnalyticsUserProperties = {
  userPrincipalId?: string | null;
} & { [key: string]: string | null | undefined };
